const EventEmitter = require('eventemitter3');

const container = document.querySelector('.soundControl');
const btnMute = container.querySelector('.soundControl__btnOnOff');
const control = new EventEmitter();

btnMute.addEventListener('click', () => {
    control.emit('toggleMuteRequest');
});

control.mute = function () {
    container.dataset.mute = 1;
};

control.unmute = function () {
    container.dataset.mute = 0;
};

module.exports = control;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/sound/soundControl.js